import React from 'react'
import { Link } from 'react-router'

const Logo = () => {
  return (
    <div className="logo fixed">
      <Link
        to="/"
        title="Zurück zur Startseite"
      >
        <img
          className="logo-musbi"
          src="/static/images/svg/musbi-logo.svg"
          alt="MusBi, Museum bildet"
        />
      </Link>
    </div>
  )
}

export { Logo as default }



// WEBPACK FOOTER //
// ./src/base/components/Logo.js